<ng-container *t="let t">
    <form [formGroup]="taxIdTypeChildForm">
        <div class="row">
            <div class="col-6">
                <tsl-form-field class="w-100">
                    <tsl-select placeholder="Tax Types" tPlaceholder="TaxIdTypeName" i18n-placeholder="@@TaxIdTypeName" [disabled]="isFormDisabled" formControlName="TaxIdTypeName" name="TaxIdTypeName">
                        <tsl-option *ngFor="let option of TaxIdList" [value]="option.taxIdType">
                            {{translate.get(option.taxIdType)}} - {{translate.get(option.description)}}
                        </tsl-option>
                    </tsl-select>
                    <tsl-error *ngIf="TaxIdTypeName.errors && (TaxIdTypeName.dirty || TaxIdTypeName.touched)">
                        <span>{{getValidationErrorMessages('Tax Types', TaxIdTypeName)}}</span>
                    </tsl-error>
                </tsl-form-field>
            </div>
            <div class="col-5" *ngIf="!showExistingValue()">
                <tsl-form-field class="w-100">
                    <input tslInput tsl-ssn-mask [tsl-taxType]="TaxIdTypeName.value" #taxIdTypeValues placeholder="" fullWidth shape="round" formControlName="TaxIdTypeValue" name="TaxIdTypeValue"/>
                    <tsl-error *ngIf="TaxIdTypeValue.fieldControl.errors && (TaxIdTypeValue.fieldControl.dirty || TaxIdTypeValue.fieldControl.touched)">
                        <span>{{getValidationErrorMessages('Tax ID', TaxIdTypeValue.fieldControl)}}</span>
                    </tsl-error>
                </tsl-form-field>
            </div>
            <div class="col-5" *ngIf="showExistingValue()">
                <tsl-form-field class="w-100">
                    <div *ngIf="isFieldDisabled">
                        <input tslInput type="text" disabled formControlName="TaxIdTypeReadValue" shape="round" readonly [value]="'*****' + TaxIdTypeValue?.last4Value" placeholder="Tax ID" fullWidth name="TextTaxIdTypeValue" tPlaceholder="TextTaxIdTypeValue" i18n-placeholder="@@TextTaxIdTypeValue" />
                        <a class="link inline-icon"  (click)="isVisible()" tooltip="Click to edit tax ID"   tslTooltip="{{ t('9048071373980503858', editTaxID) }}">
                            <tsl-icon class="input-inline">{{(isVisibility) ? 'visibility' : 'visibility_off'}}</tsl-icon>
                        </a>
                    </div>
                    <div *ngIf="!isFieldDisabled">
                        <input tslInput type="text" shape="round" readonly [value]="'*****' + TaxIdTypeValue?.last4Value" placeholder="Tax ID" fullWidth name="TextTaxIdTypeValue" tPlaceholder="TextTaxIdTypeValue" i18n-placeholder="@@TextTaxIdTypeValue" />
                        <a class="link inline-icon"  (click)="editFederalTaxId()" tooltip="Click to edit tax ID" i18n-tooltip="@@9048071373980503858"  tslTooltip="{{ t('9048071373980503858', editTaxID) }}">
                            <tsl-icon class="input-inline">edit</tsl-icon>
                        </a>
                    </div>
                </tsl-form-field>
            </div>
            <div class="col">
                <div class="w-100" *ngIf="isDeleteAvailable">
                    <tsl-icon tslSuffix size="medium" class="delete paddingLeft" (click)="deleteCurrentComponent()">delete</tsl-icon>
                </div>
            </div>
        </div>
    </form>
</ng-container>